import { navigate } from 'gatsby';

export default function (newLng, pathname, oldLng) {
    return navigate(pathname.replace(`/${oldLng}`, `/${newLng}`));
}
